module.exports = __webpack_public_path__ + "static/media/databootcamp_white.7d86c4c3.png";